import { useOptionalDependency } from 'ditox-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LNGS_TOKEN } from '@/container';
import ScrollSelector from '../common/ScrollSelector';

type LanguageSelectProps = {
  show: boolean;
  onClose: () => void;
};

const LanguageSelect = ({ show, onClose }: LanguageSelectProps) => {
  const supportedLanguages = useOptionalDependency(SUPPORTED_LNGS_TOKEN);
  const { t, i18n } = useTranslation();
  const [isLanguageSwitching, setLanguageSwitching] = useState(false);

  const handleLanguageChange = async (lang: string) => {
    setLanguageSwitching(true);

    await i18n.changeLanguage(lang);

    if (i18n.language === lang) {
      setLanguageSwitching(false);
    }

    onClose();
  };

  return (
    <>
      <ScrollSelector
        show={show}
        onCancel={onClose}
        onConfirm={handleLanguageChange}
        title={t('general-settings.language')}
        defaultValue={i18n.resolvedLanguage}
        items={
          supportedLanguages?.map(({ value, label }) => ({
            key: value,
            label,
            value,
          })) ?? []
        }
      />

      {isLanguageSwitching && (
        <div className='absolute inset-0 z-30 flex items-center justify-center bg-black/70 text-center backdrop-blur-[0.625rem]'>
          <span className='text-base font-normal text-neutral-0'>{t('general-settings.language-switching')}</span>
        </div>
      )}
    </>
  );
};
export default LanguageSelect;
